enum GuestRank {
  loyal = "loyal",
  normal = "normal",
  bad = "bad",
}

export default GuestRank;
